import client from '../client';
import { exportFile } from '../requestDownloadFile';

export default {
  getFinancePublisherBillingsList: data => {
    return client.get('finance/publisher/billings/list', {params:data}).then(res => res.data);
  },
  getFinancePublisherBillingsAgg: data => {
    return client.get('finance/publisher/billings/agg', {params:data}).then(res => res.data);
  },
  getFinancePublisherBillingsDetail: data => {
    return client.get('finance/publisher/billings/detail', {params:data}).then(res => res.data);
  },
  financePublisherBillingsSubmit: data => {
    return client.post('finance/publisher/billings/submit', data).then(res => res.data);
  },
  financePublisherBillingsDetailExport: data => {
    return exportFile('finance/publisher/billings/detail/export', data.qs, data.fileName);
  },
  financePublisherBillingsDownloadInvoice: data => {
    return client.get('finance/publisher/billings/downloadInvoice', {params:data}).then(res => res.data);
  },
  financePublisherBillingsInvoice: data => {
    return client.get('finance/publisher/billings/invoice', {params:data}).then(res => res.data);
  },
  /**2
   * 获取手动调整详情
   * @param {*} data 
   * @returns 
   * 威龙 mock: http://118.31.23.117:8077/doc.html#/%E8%B4%A2%E5%8A%A1%E7%AE%A1%E7%90%86/%E5%95%86%E5%AE%B6%E6%94%AF%E4%BB%98%E8%AE%A2%E5%8D%95/manualDetailsUsingGET
   */
  getManualAdjustmentDetails: data => {
    return client.get(`finance/publisher/billings/manual-details`, { params: data }).then(res => res.data)
  }
}
